import { type ReactNode } from 'react';

import type { Props as PageMetaProps } from '@/shared/components/PageMeta';
import PageMeta from '@/shared/components/PageMeta';

import styles from './index.module.scss';

type Props = {
  readonly children: ReactNode;
  readonly pageMeta: PageMetaProps;
};

const FirstScreenLayout = ({ children, pageMeta }: Props) => {
  return (
    <>
      <PageMeta {...pageMeta} />
      <div className={styles.wrapper}>{children}</div>
    </>
  );
};

export default FirstScreenLayout;
